import React from 'react'

const Icon: React.FC<any> = ({...props}) => {
  return (
    <svg {...props} viewBox="0 0 29 29" fill="none">
      <path fill={props.fill || '#464646'}
            d="M16.6994 6.28855C21.2338 7.50355 23.9248 12.1644 22.7098 16.6989C21.5564 21.0033 17.2965 23.6475 12.9894 22.8643C12.7597 22.8225 12.5296 22.7709 12.2995 22.7093C12.2111 22.6856 12.1235 22.6606 12.0366 22.6344C12.001 23.4577 11.8754 24.292 11.6524 25.1241C11.609 25.286 11.5624 25.446 11.5127 25.6043C11.5161 25.6052 11.5196 25.6061 11.523 25.6071C11.8324 25.69 12.1425 25.7595 12.4527 25.8159C18.2836 26.8762 24.0467 23.3007 25.6076 17.4753C27.2514 11.3405 23.6107 5.0346 17.4758 3.39077C11.341 1.74694 5.0351 5.38764 3.39127 11.5225C3.38702 11.5384 3.38281 11.5542 3.37863 11.5701C3.70496 11.6238 4.03144 11.694 4.3572 11.7813C5.01859 11.9585 5.64742 12.1981 6.23957 12.4925C6.25528 12.428 6.27177 12.3635 6.28905 12.299C7.50405 7.76449 12.1649 5.07354 16.6994 6.28855Z"/>
    </svg>
  )
}

export default Icon